<template>
  <CRow>
    
    <CCol col="12" lg="12">
      <CCard>
        <CCardHeader>
          <strong>Promocode</strong>
        </CCardHeader>
        <CCardBody >
          <CForm @submit.prevent="updatePromocode" id="form">
            <CRow>
              <CCol col=12>
                <CAlert
                  :show.sync="dismissCountDown"
                  closeButton
                  color="danger"
                  fade
                >
                  {{errorMsg}}
                </CAlert>
              </CCol>
              <CCol col=6>
                <CInput
                  label="Código"
                  v-model="code"
                  bottom
                  type="text"
                  required
                />
              </CCol>

              <CCol col=6>
                <CInput
                  label="Desconto (%)"
                  v-model="discount"
                  bottom
                  min="0" max="100"
                  type="number"
                  required
                />
              </CCol>

              <CCol col=6>
                <CInput
                  label="Data de expiração"
                  v-model="expire_date"
                  bottom
                  type="date"
                  required
                />
              </CCol>

              <CCol col=5>
                <CInput
                  label="Limite de utilizações"
                  v-model="max_uses"
                  bottom
                  min="1" max="10000"
                  type="number"
                  required
                />
              </CCol>

              <CCol col=1 class="text-center">
                <label>Ativo</label>
                <input label="Ativo" type="checkbox" v-model="active" />
              </CCol>
              
              <CCol col=12 class="text-center">
                <CButton size="sm" color="warning" @click="goBack()" style="margin-right: 10px;">Voltar</CButton>
                <CButton type="submit" size="sm" color="success">Salvar</CButton>
              </CCol>
            </CRow>
            
              
          </CForm>
        </CCardBody>
        
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Promocodes from "@/services/PromocodeDataService";
export default {
  name: 'Promocode',
  data: () => {
    return {
      id: '',
      dismissCountDown: 0,
      errorMsg: '',
      active: false,
      code: '',
      discount: '',
      expire_date: '',
      max_uses: ''
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.getPromocodeData();
  },
  methods: {
    updatePromocode(){
      Promocodes.updatePromocode(this.id, this.active, this.code, this.discount, this.expire_date, this.max_uses)
      .then(response => {
        let message = {
          status: 'success',
          text: '<strong>Promocode atualizado:</strong> ' + response.data.id+' - '+response.data.code
        }
        EventBus.$emit('showMessage', message);
        this.$router.push('/promocodes');
      })
    },
    goBack() {
      this.$router.push('/promocodes')
    },
    getPromocodeData(){
      Promocodes.get(this.id)
      .then(response => {
        this.active = response.data.active
        this.code = response.data.code
        this.discount = response.data.discount
        this.expire_date = new Date(response.data.expire_date).toISOString().slice(0, 10)
        this.max_uses = response.data.max_uses
      })
      .catch(e => {
          alert(e);
        });
    }

  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_MODERATOR');
      }

      return false;
    },
    showAdminOrModeratorBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_MODERATOR') || this.currentUser.roles.includes('ROLE_ADMIN');
      }

      return false;
    },
  }
}
</script>
<style scoped>
  input[type="checkbox"]{
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
</style>